/**
 * SideNav - Left sidebar for AppShell.menu slot.
 * Links to catalog and settings. Active route is highlighted.
 */
import { Box, Button } from '@nimbus-ds/components';
import { useLocation, useNavigate } from 'react-router-dom';
import { useNexo } from './nexo-provider';

export function SideNav() {
  const { t } = useNexo();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const isActive = (path: string) =>
    pathname === path || (path !== '/' && pathname.startsWith(path));

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="2"
      height="100%"
      padding="4"
    >
      <Button
        appearance={isActive('/') ? 'primary' : 'transparent'}
        onClick={() => navigate('/')}
      >
        {t('nav.catalog')}
      </Button>
      <Button
        appearance={isActive('/settings') ? 'primary' : 'transparent'}
        onClick={() => navigate('/settings')}
      >
        {t('nav.settings')}
      </Button>
    </Box>
  );
}
